export const visit = (vm, at) => {
vm(require("foundations-components/lang/zh-cn.lyaml"));
at({ "zh-cn": { "placeholder": "\u5360\u4F4D\u7B26" } });
};